import EventsService from '../services/EventsService';

class EventsController {
  async getUserEvents(email) {
    try {
      const response = await EventsService.getUserEvents(email);
      return {
        success: true,
        data: response.data.data || response.data || []
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  }

  async getTodayEvents(email) {
    try {
      const events = await EventsService.getTodayEvents(email);
      return {
        success: true,
        data: events
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message
      };
    }
  }

  async getEventAttendees(eventId, email) {
    try {
      const response = await EventsService.getEventAttendees(eventId, email);
      const attendeesData = response.data.data.attendees || response.data.attendees || [];
      return {
        success: true,
        data: attendeesData
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Error al obtener participantes';
      return {
        success: false,
        error: errorMessage
      };
    }
  }

  async getOrCreateEvent(googleEventId, eventDetails) {
    try {
      const eventDbId = await EventsService.getOrCreateEvent(googleEventId, eventDetails);
      return {
        success: !!eventDbId,
        data: eventDbId
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }
}

export default new EventsController();